import {
  MONTHLY,
  ANNUAL,
  FRIENDLY_ITEM_NAMES, BASIC_PLAN,
} from './constants';

export function getChargebeeId(name, currency, isMonthly) {
  const frequency = isMonthly ? MONTHLY : ANNUAL;
  return [name, currency, frequency].join('-');
}

export function getIdParts(id) {
  const match = /^([A-Za-z0-9\-_]+)-(CAD|USD)-([A-Za-z0-9\-_]+)$/i.exec(id);
  if (!match || !match[1] || !match[2] || !match[3]) {
    return null;
  }
  const groups = {
    id: match[1],
    currency: match[2],
    frequency: match[3],
  };
  return groups;
}

export function stripExtrasFromId(id) {
  const parts = getIdParts(id);
  if (!parts) {
    return null;
  }
  const { id: planId, currency, frequency } = parts;
  return {
    id: planId,
    currency,
    isMonthly: frequency === MONTHLY,
  };
}

export function humanizePlan(planId) {
  const parts = stripExtrasFromId(planId);
  if (parts) {
    return FRIENDLY_ITEM_NAMES[parts.id];
  }
  return planId.replace('-', ' ');
}

export function isBasicPlan(user) {
  if (!user.chargebee_info?.plan_id) {
    return false;
  }
  if (user.chargebee_info.plan_id === BASIC_PLAN) {
    return true;
  }
  const idParts = getIdParts(user.chargebee_info.plan_id);
  return idParts && idParts.id === BASIC_PLAN;
}

export function getButtonText(currentPlan, isInTrial, plan) {
  if (currentPlan.planId === plan.id && !isInTrial) {
    return 'Current Plan';
  }
  if (typeof plan.price === 'string') {
    return 'Contact Us';
  }
  if (plan.level < currentPlan.level && !isInTrial) {
    return 'Downgrade';
  }
  return 'Subscribe';
}

export function isSelected(currentPlan, isInTrial, plan) {
  if (isInTrial) return false;
  return currentPlan.planId === plan.id;
}

export function isPlanUnavailable(currentPlan, plan) {
  return (
    currentPlan.planId === plan.id
    || typeof plan.price === 'string'
    || plan.level < currentPlan.level
  );
}

export function getButtonColor(currentPlan, plan, colors) {
  return !isPlanUnavailable(currentPlan, plan) ? colors.grainfoxAIButton : undefined;
}

export function getTextColor(currentPlan, plan) {
  return isPlanUnavailable(currentPlan, plan) ? 'black' : 'white';
}

export function getCellValue(plan, featureOrItem) {
  return plan.sections?.[featureOrItem.id] || featureOrItem.default;
}

export function filterByFlag(items, flags) {
  return items.filter((item) => !item.flag || flags[item.flag]);
}

export function getPriceOverride(currentPlan, plan) {
  if (currentPlan?.planId !== plan?.id) {
    return null;
  }
  const currentAmount = currentPlan.amount / 100;
  return currentAmount < plan.price?.number ? currentAmount : null;
}

export function mapPlansWithInfo({
  plans,
  currentPlan,
  isInTrial,
  flags,
  colors,
}) {
  return filterByFlag(plans, flags).map((plan) => ({
    ...plan,
    isSelected: isSelected(currentPlan, isInTrial, plan),
    buttonText: getButtonText(currentPlan, isInTrial, plan),
    backgroundColor: getButtonColor(currentPlan, plan, colors),
    textColor: getTextColor(currentPlan, plan),
    priceOverride: getPriceOverride(currentPlan, plan),
  }));
}
